module.exports = __webpack_public_path__ + "static/media/Fondo4.8c4600e1.mp4";